import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfig } from '@shared/utils/app-config';

@Injectable()
export class Check404Interceptor implements HttpInterceptor {
  constructor(private router: Router, private appConfig: AppConfig) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404 && error.url?.includes(this.appConfig.baseApiUrl) && !request.url.includes('/unassign') && !request.url.includes('/register')) {
          this.router.navigate(['Error']);
        }

        return throwError(() => error);
      })
    );
  }
}
